export default __webpack_public_path__ + "static/media/print.d6450c9e.svg";